import auth from '@/middleware/modules/auth'
import whitelabelApp from '@/middleware/modules/whitelabel-app'
import { checkAppLimits, checkClientAppLimits } from '@/middleware/modules/campaigns'
import { viUiEnabled } from '@/utils/features'

const CampaignEdit = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignEdit.vue')
const GroupCampaignEdit = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/GroupCampaignEdit.vue')
const BriefCampaignEdit = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/BriefCampaignEdit.vue')
const CampaignView = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignView.vue')
const CampaignsIndex = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignsIndex.vue')

const CampaignsList = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignsList.vue')

const TabCampaignOverview = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignOverview.vue')
const TabCampaignAnalytics = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignAnalytics.vue')
const TabCampaignAnalyticsOld = () =>
  import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignAnalytics-old.vue')
const TabCampaignAnalyticsPOE = () =>
  import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignAnalyticsPOE.vue')
const TabCampaignAIInsights = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignAIInsights.vue')

const TabCampaignContent = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignContent.vue')
const TabCampaignContentApproval = () =>
  import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignContentApproval.vue')
const TabCampaignMessages = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignMessages.vue')
const TabCampaignActivity = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignActivityTab.vue')
const TabCampaignAiContent = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignAiContent.vue')

//Reports
const TabCampaignReports = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CampaignReports.vue')
const CampaignPrintReports = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/reports/PrintReports.vue')
const CampaignPrintAiInsights = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/reports/PrintAiInsights.vue')

const CreatorsAnalytics = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignTabs/CreatorsAnalytics.vue')

// Creators
const CreatorOverview = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/Creator/CreatorOverview.vue')

// Groups
const AssignBriefToGroupEdit = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/AssignBriefToGroupEdit.vue')
const GroupIndex = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/GroupTabs/GroupIndex.vue')
const BriefIndex = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/Brief/BriefIndex.vue')
const GroupCreators = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/GroupTabs/Creators.vue')
const GroupRecommended = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/GroupTabs/Recommended.vue')
const GroupAIMatching = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/GroupTabs/AIMatching.vue')
const GroupBlocked = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/GroupTabs/Blocked.vue')
const GroupBrandExcluded = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/GroupTabs/BrandExcluded.vue')
const FavoriteCreators = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/FavoriteCreators.vue')
const InvitedCreators = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/InvitedCreators.vue')
const CreatorsTag = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CreatorsTags.vue')

const TaggedCreators = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/TaggedCreators.vue')

const InviteCreatorsForm = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/InviteCreators.vue')

const ContentApprovalDownload = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/DownloadFileView.vue')

const CampaignMediasDownload = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/CampaignMediasDownload.vue')

const ReviewCreators = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/campaigns/ReviewCreators.vue')

const PrintReportPoe = () => import(/* webpackChunkName: "_v-campaign" */ '@/views/reports/PrintReportsPoe.vue')

export default [
  {
    path: 'campaign/:id(\\d+)',
    name: 'campaign-view',
    component: CampaignView,
    props: (route) => ({ querySearch: route.query.search }),
    redirect: { name: 'campaign-overview' },
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits, checkClientAppLimits],
    },
    children: [
      {
        path: 'overview',
        name: 'campaign-overview',
        component: TabCampaignOverview,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-overview',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
      {
        path: 'analytics/:section(total-creators|total-content|total-impressions|total-reach|total-engagement)?',
        name: 'campaign-analytics',
        component: TabCampaignAnalytics,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-analytics',
          middleware: [auth],
        },
      },
      {
        path: 'analytics-poe',
        name: 'campaign-analytics-poe',
        component: TabCampaignAnalyticsPOE,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-analytics',
          middleware: [auth],
        },
      },
      {
        path: 'analytics-old',
        name: 'campaign-analytics-old',
        component: TabCampaignAnalyticsOld,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-analytics',
          middleware: [auth],
        },
      },
      {
        path: 'ai-insights',
        name: 'campaign-ai-insights',
        component: TabCampaignAIInsights,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-ai-insights',
          middleware: [auth],
        },
      },
      {
        path: 'content',
        name: 'campaign-content',
        props: (route) => ({ querySearch: route.query.search }),
        component: TabCampaignContent,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-content',
          middleware: [auth],
        },
      },
      {
        path: 'reports',
        name: 'campaign-reports',
        component: TabCampaignReports,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-reports',
          middleware: [auth],
        },
      },
      {
        path: 'content-approval',
        name: 'campaign-content-approval',
        props: (route) => ({ querySearch: route.query.search }),
        component: TabCampaignContentApproval,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-content-approval',
          middleware: [auth],
        },
      },
      {
        path: 'messages',
        name: 'campaign-messages',
        props: (route) => ({ querySearch: route.query.search }),
        component: TabCampaignMessages,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-messages',
          middleware: [auth],
        },
      },
      {
        path: 'activity',
        name: 'campaign-activity',
        component: TabCampaignActivity,
        meta: {
          layout: 'app-layout',
          tab: 'campaign-activity',
          middleware: [auth],
        },
      },
      {
        path: 'ai-content',
        name: 'campaign-ai-content',
        component: TabCampaignAiContent,
        // SRR-2981: AI (VI) content is hidden unless VIRTUAL_INFLUENCERS_UI_ENABLED.
        beforeEnter: (to, from, next) => (viUiEnabled() ? next() : next({ name: 'campaign-overview', params: to.params })),
        meta: {
          layout: 'app-layout',
          tab: 'campaign-ai-content',
          middleware: [auth],
        },
      },
    ],
  },
  {
    path: 'campaign/:id(\\d+)/print-reports',
    name: 'campaign-print-reports',
    component: CampaignPrintReports,
    meta: {
      layout: 'print-layout',
      middleware: [auth],
    },
  },
  {
    path: 'campaign/:id(\\d+)/print-reports-poe',
    name: 'campaign-print-reports-poe',
    component: PrintReportPoe,
    meta: {
      layout: 'print-layout',
      middleware: [auth],
    },
  },
  {
    path: 'campaign/:id(\\d+)/print-ai-insights',
    name: 'campaign-print-ai-insights',
    component: CampaignPrintAiInsights,
    meta: {
      layout: 'print-layout',
      middleware: [auth],
    },
  },
  {
    path: 'campaigns',
    name: 'campaigns',
    component: CampaignsIndex,
    props: (route) => ({ querySearch: route.query.search }),
    redirect: { name: 'campaigns-all' },
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits],
    },
    children: [
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'all',
        name: 'campaigns-all',
        component: CampaignsList,
        meta: {
          layout: 'app-layout',
          tab: 'campaigns-all',
          middleware: [auth, checkAppLimits],
          campaign_state: null,
        },
      },
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'active',
        name: 'campaigns-active',
        component: CampaignsList,
        meta: {
          layout: 'app-layout',
          tab: 'campaigns-active',
          middleware: [auth, checkAppLimits],
          campaign_state: 'active',
        },
      },
      {
        props: (route) => ({ querySearch: route.query.search }),
        path: 'draft',
        name: 'campaigns-draft',
        component: CampaignsList,
        meta: {
          layout: 'app-layout',
          tab: 'campaigns-draft',
          middleware: [auth, checkAppLimits],
          campaign_state: 'draft',
        },
      },
      {
        path: 'scheduled',
        name: 'campaigns-scheduled',
        component: CampaignsList,
        meta: {
          layout: 'app-layout',
          tab: 'campaigns-scheduled',
          middleware: [auth, checkAppLimits],
          campaign_state: 'scheduled',
        },
      },
      {
        path: 'completed',
        name: 'campaigns-completed',
        component: CampaignsList,
        meta: {
          layout: 'app-layout',
          tab: 'campaigns-completed',
          middleware: [auth, checkAppLimits],
          campaign_state: 'completed',
        },
      },
      {
        path: 'pending',
        name: 'campaigns-pending',
        component: CampaignsList,
        meta: {
          layout: 'app-layout',
          tab: 'campaigns-pending',
          middleware: [auth, checkAppLimits],
          campaign_state: 'pending',
        },
      },
      {
        path: 'approved',
        name: 'campaigns-approved',
        component: CampaignsList,
        meta: {
          layout: 'app-layout',
          tab: 'campaigns-approved',
          middleware: [auth, checkAppLimits],
          campaign_state: 'approved',
        },
      },
    ],
  },
  {
    path: 'campaign/:id(\\d+)/creators',
    props: (route) => ({ querySearch: route.query.search }),
    name: 'campaign-creators-analytics',
    component: CreatorsAnalytics,
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits, checkClientAppLimits],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/group/new',
    name: 'campaign-group-new',
    component: GroupCampaignEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/group/:group_id(\\d+)/edit',
    name: 'campaign-group-edit',
    component: GroupCampaignEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/brief/new',
    name: 'campaign-brief-new',
    component: BriefCampaignEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/brief/:brief_id(\\d+)/edit',
    name: 'campaign-brief-edit',
    component: BriefCampaignEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/invite/new',
    name: 'campaign-invite-new',
    component: InviteCreatorsForm,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },

  {
    path: 'campaign/new',
    name: 'campaign-new',
    component: CampaignEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/creator/:creator_id(\\d+)',
    name: 'campaign-creator-overview',
    component: CreatorOverview,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaign-view'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/edit',
    name: 'campaign-edit',
    component: CampaignEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/group/:group_id(\\d+)',
    name: 'campaign-group-view',
    component: GroupIndex,
    redirect: { name: 'campaign-group-creators' },
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits, checkClientAppLimits],
      breadcrumbs: ['campaign-view'],
    },
    children: [
      {
        path: 'creators',
        name: 'campaign-group-creators',
        component: GroupCreators,
        meta: {
          layout: 'app-layout',
          tab: 'creators',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
      {
        path: 'recommended-creators',
        name: 'campaign-recommended-creators',
        component: GroupRecommended,
        meta: {
          layout: 'app-layout',
          tab: 'recommended',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
      {
        path: 'ai-matching',
        name: 'campaign-ai-matching',
        component: GroupAIMatching,
        meta: {
          layout: 'app-layout',
          tab: 'ai_matching',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
      {
        path: 'blocked-creators',
        name: 'campaign-blocked-creators',
        component: GroupBlocked,
        meta: {
          layout: 'app-layout',
          tab: 'blocked',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
      {
        path: 'brand-excluded-creators',
        name: 'campaign-brand-excluded-creators',
        component: GroupBrandExcluded,
        meta: {
          layout: 'app-layout',
          tab: 'brand_excluded',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
      {
        path: 'favorite-creators',
        name: 'campaign-favorite-creators',
        component: FavoriteCreators,
        meta: {
          layout: 'app-layout',
          tab: 'favorite_creators',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
      {
        path: 'invite-creators',
        name: 'campaign-invited-creators',
        component: InvitedCreators,
        meta: {
          layout: 'app-layout',
          tab: 'invite',
          middleware: [auth, checkAppLimits, checkClientAppLimits],
        },
      },
    ],
  },
  {
    path: 'campaign/:id(\\d+)/brief/:brief_id(\\d+)',
    name: 'campaign-brief-view',
    props: (route) => ({ querySearch: route.query.search }),
    component: BriefIndex,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaign-view'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/group/:group_id(\\d+)/:brief_id(\\d+)?/link',
    name: 'campaign-group-brief',
    component: AssignBriefToGroupEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits, checkClientAppLimits],
      breadcrumbs: ['campaign-view'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/brief/:brief_id(\\d+)/:group_id(\\d+)?/link',
    name: 'campaign-brief-group',
    component: AssignBriefToGroupEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits, checkClientAppLimits],
      breadcrumbs: ['campaign-view'],
    },
  },
  {
    path: 'campaign/:id(\\d+)/link',
    name: 'campaign-brief-link',
    component: AssignBriefToGroupEdit,
    meta: {
      layout: 'app-layout',
      middleware: [auth, checkAppLimits, checkClientAppLimits],
      breadcrumbs: ['campaign-view'],
    },
  },
  {
    path: 'myCreators/favorite-creators',
    name: 'myCreators-favorite-creators',
    component: FavoriteCreators,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'myCreators/invited-creators',
    name: 'myCreators-invited-creators',
    component: InvitedCreators,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'myCreators/invited-creators/new',
    name: 'myCreators-invited-new',
    component: InviteCreatorsForm,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'myCreators/tagged',
    name: 'myCreators-tagged',
    component: CreatorsTag,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'campaigns/:id(\\d+)/tag',
    name: 'campaign-tag',
    component: TaggedCreators,
    meta: {
      layout: 'app-layout',
      middleware: [auth],
      breadcrumbs: ['campaigns'],
    },
  },
  {
    path: 'content-approval-download/:id(\\d+)',
    name: 'content-approval-download',
    props: (route) => ({ querySearch: route.query.search }),
    component: ContentApprovalDownload,
    meta: {
      layout: 'app-layout',
      tab: 'content-approval-download',
      middleware: [auth],
    },
  },
  {
    path: 'campaign/:id(\\d+)/content/download/:downloadId(\\d+)',
    name: 'campaign-content-download',
    component: CampaignMediasDownload,
    meta: {
      layout: 'app-layout',
      tab: 'campaign-content-download',
      middleware: [auth],
    },
  },
  {
    path: 'campaigns/review-creators',
    name: 'campaigns-review-creators',
    component: ReviewCreators,
    meta: {
      layout: 'app-layout',
      middleware: [auth, whitelabelApp],
      breadcrumbs: ['campaigns'],
    },
  },
]
